export default __webpack_public_path__ + "static/media/oven-glove.db92d4fe.svg";